import { CssBaselineProps } from '@mui/material'

import { CustomRow, RowStyles } from './row.styles'

interface RowProps extends RowStyles {
  children?: any
  gap?: any
  onClick?: () => void
  style?: React.CSSProperties
}

export const Row = ({
  children,
  onClick,
  justifyContent,
  alignItems,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  gap,
  flexWrap,
  style
}: RowProps) => (
  <CustomRow
    onClick={onClick}
    justifyContent={justifyContent}
    alignItems={alignItems}
    marginTop={marginTop}
    marginBottom={marginBottom}
    marginLeft={marginLeft}
    marginRight={marginRight}
    gap={gap}
    flexWrap={flexWrap}
    style={style}
  >
    {children}
  </CustomRow>
)
